<template>
  <div class="page-add">
    <div class="add-title">
      {{ addTitle }}
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="120px"
      class="form"
      size="small"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="页面标题：" prop="pageTitle" required>
            <el-input
              v-model="ruleForm.pageTitle"
              placeholder="页面标题"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="是否默认：" prop="isDefault" required>
            <el-radio-group v-model="ruleForm.isDefault" @change="radioChange">
              <el-radio
                v-for="(item, i) in skipList"
                :key="i"
                :label="item.paramKey"
                >{{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="生效时间：" prop="times" required>
            <el-date-picker
              v-model="ruleForm.times"
              type="datetimerange"
              placeholder="选择日期时间"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00']"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="启动页配图："
            prop="pageUrl"
            :rules="{
              required: true,
              message: '请上传图片',
            }"
          >
            <div
              v-if="ruleForm.pageUrl"
              id="video-output"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="ruleForm.pageUrl" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer = true"
                ></i>
                <i class="el-icon-delete delete" @click.stop="deleteCover"></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadCover"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!ruleForm.pageUrl" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="upload_tip">
              <p>启动页图片</p>
              <p class="img_tip">建议尺寸：1125px*2436px</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="播放时长(秒)：" prop="playDuration" required>
            <el-input-number
              v-model="ruleForm.playDuration"
              :min="1"
              :max="5"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item style="text-align: center">
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <el-button @click="goBack">取消</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[ruleForm.pageUrl]"
    />
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import rulesFactory from "@/utils/rules";
import FileHandler from "@/utils/file";
import { getDataMap } from "@/api/sysParam";
import { pageAdd, pageEdit, getPageInfo } from "@/api/startup";

export default {
  components: { ElImageViewer },
  data() {
    return {
      addTitle: "新增启动页",
      skipList: [],
      showCover: false,
      showViewer: false,
      ruleForm: {
        pageTitle: "",
        isDefault: "0",
        times: [],
        pageUrl: "",
        playDuration: 0,
      },
      rules: {
        pageTitle: [
          { required: true, message: "请输入页面标题", trigger: "blur" },
          rulesFactory.size("最多输入20个字", 0, 20),
        ],
        isDefault: [
          {
            required: true,
            message: "请选择是否默认",
            trigger: ["blur", "change"],
          },
        ],
        times: [
          {
            required: true,
            message: "请选择时间",
            trigger: ["blur", "change"],
          },
        ],
        pageUrl: [
          {
            required: true,
            message: "请选择图片",
            trigger: ["blur", "change"],
          },
        ],
        playDuration: [
          {
            required: true,
            message: "请输入播放时长",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  created() {
    getDataMap("IS_DEFAULT").then((res) => {
      if (!res || res.code != 0) return;
      this.skipList = res.data;
    });
    if (this.$route.query.uuid) {
      this.initEdit();
    }
  },
  methods: {
    goBack() {
      this.$router.push('/startupConfig');
    },
    initEdit() {
      this.addTitle = "编辑启动页";
      getPageInfo(this.$route.query.uuid).then((res) => {
        if (!res || res.code != 0) return;
        let { data } = res;
        this.ruleForm = {
          ...data,
          times: [data.startTime, data.endTime],
          isDefault: String(data.isDefault),
        };
      });
    },
    radioChange(data) {
      console.log(data);
    },
    closeViewer() {
      this.showViewer = false;
    },
    async uploadCover(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      const gif = await FileHandler.isGif(file);
      if (!(image || gif)) {
        this.$message({
          message:
            "请上传格式为png、jpg、gif格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`startup/img`, file).then((res) => {
        const { url } = res;
        this.ruleForm.pageUrl = url;
      });
    },
    deleteCover() {
      if (this.$refs["coverUpload"] !== undefined) {
        this.$refs["coverUpload"].clearFiles();
      }
      this.ruleForm.pageUrl = "";
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let { times } = this.ruleForm;
              let params = {
                ...this.ruleForm,
                startTime: times[0],
                endTime: times[1],
              };
              if (this.$route.query.uuid) {
                pageEdit(params).then((res) => {
                  if (!res || res.code != 0) return;
                  this.goBack();
                  this.$refs["ruleForm"].resetFields();
                });
              } else {
                pageAdd(params).then((res) => {
                  if (!res || res.code != 0) return;
                  this.goBack();
                  this.$refs["ruleForm"].resetFields();
                });
              }
            })
            .catch((_) => _);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

#video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}

.autocomplete {
  width: 100%;
}

.el-autocomplete-suggestion {
  display: none;
}
</style>
